import React from 'react';
import i18nOptions from '__config/i18n';

// NOTE: This file is changed by the `yarn creator` command.
// Do not remove any of the !IMPORTANT! comments

// !IMPORTANT! - Importing contexts
// import { NextIntlClientProvider as NextIntlProvider, IntlErrorCode } from 'next-intl';
import {
  NextIntlClientProvider as NextIntlProvider,
  IntlErrorCode
} from 'next-intl';
import { AnalyticsProvider } from 'providers/analytics';
import { WindowsProvider } from 'providers/windows';
import { UserSettingsProvider } from 'providers/user-settings';
import { UiProvider } from 'providers/ui';
import { ContextMenuProvider } from 'providers/context-menu';
import { PermissionsProvider } from 'providers/permissions';
import { AuthProvider } from 'providers/auth';
import { TenantProvider } from 'providers/tenant';
import { ApiProvider } from 'providers/api';
import { DataStructuresProvider } from 'providers/datastructures';
// !IMPORTANT! - End of importing contexts // do not remove this comment

export function withContext(Provider, providerData, Component) {
  return <Provider {...providerData}>{Component}</Provider>;
}

export function withContexts (comp, arr) {
  for (let i = 0; i < arr.length; i++ ) {
    comp = withContext(arr[i][0], arr[i][0], comp);
  }
  return comp;
}

function applyContexts(comp, data) {

  // !IMPORTANT! - Using the list of contexts. The order of them matter here.
  comp = withContext(AnalyticsProvider, {}, comp);
  comp = withContext(WindowsProvider, {}, comp);
  comp = withContext(TenantProvider, {}, comp);
  comp = withContext(UserSettingsProvider, {}, comp);
  comp = withContext(UiProvider, {}, comp);
  comp = withContext(ContextMenuProvider, {}, comp);
  comp = withContext(PermissionsProvider, {}, comp);
  comp = withContext(DataStructuresProvider, {}, comp);
  comp = withContext(AuthProvider, {}, comp);
  comp = withContext(ApiProvider, {}, comp);
  // !IMPORTANT! - End of using contexts // do not remove this comment


  // let's add i18n as the last one, so other contexts can use it too
  // console.log(1, JSON.stringify(comp));
  comp = withContext(NextIntlProvider, {

    onError (error) {
      // will be treated by the fallback
    },

    getMessageFallback ({namespace, key, error}) {
      if (!key) {
        console.warn(`When using translations, you MUST pass a key to your t() call.`);
        return '';
      }

      const path = [namespace, key].filter((part) => part != null).join('.');

      const showMessages = i18nOptions.verbosity === "0";

      if (error.code === IntlErrorCode.MISSING_MESSAGE) {
        showMessages && console.info(`[i18n] :: ${path} is not yet translated`);

        return i18nOptions.defaultFallback === '*'
          ? key
          : i18nOptions.defaultFallback || '';
      } else {
        showMessages && console.error(
          `[i18n] :: Error with "${path}", please check its format.`,
          error
        );
        return `[i18n] :: Error with "${path}"`;
      }
    },

    now: new Date(),
    locale: (data?.pageProps?.messages)
      ? (data?.pageProps.locale || 'en') // undefined will use default locale
      : i18nOptions.defaultLocale || 'en',
    messages: data?.pageProps?.messages, // uses the list of messages coming from the page render
    ...i18nOptions,
  }, comp);

  return comp;
}

export {
  applyContexts
};
